import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import koalaUtils from "src/helpers/koala/koalaUtils";
import { KoalaProduct } from "src/types/koala/KoalaProduct";
import { KoalaVariant } from "src/types/koala/KoalaVariant";

export default function useUrlVariant(product: KoalaProduct, initialVariant?: KoalaVariant) {
  const router = useRouter();
  const [variant, setVariant] = useState(initialVariant);

  useEffect(
    function getAndSetVariantId() {
      let variant = koalaUtils.getVariantFromQuery(product, router.query);
      if (!variant) variant = product.variants.find(koalaUtils.isVariantAvailable);
      setVariant(variant);
    },
    [router.query, product]
  );

  return variant;
}
